'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _experiumPlayerHelpersLegacy = require('experium-player-helpers-legacy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Text = function Text(_ref) {
    var text = _ref.text;
    return _react2.default.createElement(
        _experiumPlayerHelpersLegacy.BaseUrlContext.Consumer,
        null,
        function (baseUrlContext) {
            return _react2.default.createElement('span', { dangerouslySetInnerHTML: {
                    __html: (0, _experiumPlayerHelpersLegacy.parseText)(text, baseUrlContext)
                } });
        }
    );
};

Text.propTypes = {
    text: _propTypes2.default.string.isRequired
};

exports.default = Text;